import React, { useEffect, useState } from "react";
import { Empty } from 'antd';
import AccountTransactionListComponent from './AccountTransactionListComponent'
import RequestHandler from "../../../../util/RequestHandler";

const AccountTransactionGoingList = (props) => {
  const [accountsList, setAccountList] = useState([])
  const [dataState, setDataState] = useState([{ skip: 0, take: 5 }]);
  const [skip, setSkip] = useState(0);

  useEffect(() => {
    RequestHandler.get(`/AccountTransaction?$filter=Contains(debtOrCredit,'B')  and isErpActivity eq false  &$count=true&$skip=${skip}&$top=${5}`).then(response => {
      setAccountList(response?.value ?? []);
    });
  }, [setDataState, skip, setSkip]);

  return (
    <div>
      {
        accountsList.length === 0 ? <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Veri Yok" /> :
          <AccountTransactionListComponent data={accountsList} isDigitHomePage={props.isDigitHomePage}/>
      }
    </div>
  )
}

export default AccountTransactionGoingList;
